import React, {useEffect} from 'react'
import styles from './styles.module.css'
import Container from '@packages/justo-parts/lib/components/Container'
import useQuery from '@packages/apollo-hooks/lib/useApolloQuery'
import gql from 'graphql-tag'
import useWebsiteId from '@hooks/useWebsiteId'
import useMutate from '@packages/apollo-hooks/lib/useMutate'
import logger from '@helpers/logger'
import {useRouter} from 'next/router'

export default function Coupon(props) {
  const websiteId = useWebsiteId()
  const router = useRouter()
  const couponCode = router.query.coupon

  const {preferences} = useQuery({
    query: gql`
      query getUserpreferences($websiteId: ID) {
        preferences: userPreferences(websiteId: $websiteId) {
          _id
          couponCode
          cart {
            websiteId
            couponStatus {
              code
              description
              errorMessage
            }
          }
        }
      }
    `,
    variables: {websiteId},
    omit: !couponCode
  })

  const mutate = useMutate()

  const setCode = async () => {
    const response = await mutate({
      mutation: gql`
        mutation setUserPreferences($websiteId: ID, $couponCode: String) {
          preferences: setUserPreferences(websiteId: $websiteId, couponCode: $couponCode) {
            _id
            couponCode
            cart {
              websiteId
              couponStatus {
                code
                description
                errorMessage
              }
            }
          }
        }
      `,
      variables: {
        websiteId,
        couponCode
      }
    })

    if (
      !response ||
      !response.preferences ||
      !response.preferences.cart ||
      !response.preferences.cart.couponStatus ||
      !response.preferences.cart.couponStatus.code
    ) {
      logger.warn('No existe información de cupón', response.preferences)
      alert('Cupón no encontrado')
      return
    }
    if (preferences.cart?.couponStatus?.errorMessage) {
      alert(preferences.cart.couponStatus.errorMessage)
    }
  }

  useEffect(() => {
    if (!couponCode) return
    setCode()
    router.push({query: {coupon: ''}})
  }, [])

  if (!couponCode) return null

  if (!preferences.cart || !preferences.cart.couponStatus || !preferences.cart.couponStatus.code) {
    return null
  }

  return (
    <div className={styles.container}>
      <Container>
        <div className={styles.inner}>
          <div className={styles.description}>{preferences.cart.couponStatus.description}</div>
          <div className={styles.code}>{preferences.cart.couponStatus.code}</div>
        </div>
      </Container>
    </div>
  )
}
